import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import { withTranslation, Trans } from "react-i18next";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import HomeIcon from "@material-ui/icons/Home";
import imgUrl from "../../assets/images/imageUrl.js";
import OffileDb from '../../config/pouchDB';
import Loader from "../loaders/loader";
import { setcomponentbgcolor } from "../../redux/actions/appActions";

const Header = (props) => {
  let history = useHistory();
  const { t } = props;
  const { templateID } = props;
  const [headerlogo, setLogo] = React.useState(imgUrl.logo);
  const [isLoading, setisLoading] = React.useState(true);
  let colorStyles = templateID == 2 ? { color: props.componentbgcolor } : {};

  useEffect(() => {
    // Update the document title using the browser API
    OffileDb.setDatabase()
    getAppLogos();
  })

  function getAppLogos() {
    var that = this
    if (navigator.onLine) {
      OffileDb.getData('applogos').then(function (result) {
        if (!result.status && result.status != 404) {
          let hlogo = result.data.brandingDetails.filter(o => o.tagline == "headerlogo").map(o => o.icon)[0] || imgUrl.logo;
          let flogo = result.data.brandingDetails.filter(o => o.tagline == "footerlogo").map(o => o.icon)[0] || imgUrl.poweredby;
          setLogo(hlogo);         
        } 
        setisLoading(false)
      });
    } else {
      setisLoading(false)
    }
  }

  function handleClickBack() {

    /**
     * CONDITIONAL GO BACK FOR LEVEL 2 ROUTING 
     * (NEED TO FIND A BETTER WAY TO HANDLE)
     * */

    console.log(history.location.pathname)
    switch (history.location.pathname) {
      case '/layout/knowyourrights':
        history.push("/layout");
        // localStorage.setItem('BotInnit', "true");
        break;
      case '/layout/getknowledgeable':
        history.push("/layout");
        // localStorage.setItem('BotInnit', "true");
        break;
      case '/layout/information':
        history.push("/layout");
        // localStorage.setItem('BotInnit', "true");
        break;
      case '/layout/nearme':
        history.push("/layout");
        // localStorage.setItem('BotInnit', "true");
        break;
      case '/layout/peerchat':
        history.push("/layout");
        // localStorage.setItem('BotInnit', "true");
        break;
      case '/layout/services':
        history.push("/layout");
        // localStorage.setItem('BotInnit', "true");
        break;
      case '/layout/settings':
        history.push("/layout");
        // localStorage.setItem('BotInnit', "true");
        break;
      default:
        history.goBack();
        break;
    }
  }

  function handleClickHome() {
    localStorage.setItem('componentbgcolor', "#009596")
    props.setcomponentbgcolor("#009596")
    history.push("/layout");
    // localStorage.setItem('BotInnit', "true");
  }


  return (
    <>
      <Grid item xs={12} className="zero gk-page">
        <div className="onboardingheaderdiv homepageheaderdiv homepageInnderheaderdiv">
          <Grid container spacing={3} className="gridcontainer">
            <Grid item xs={1} className="zero">
              <IconButton
                edge="start"
                className="menubtn"
                color="inherit"
                aria-label="menu"
                onClick={() => handleClickBack()}
              >
                <ArrowBackIosIcon style={colorStyles} />
              </IconButton>
            </Grid>

            {
              templateID == 1 ? (            
              <Grid item xs={10} className="zero appnameholder">
              <h3 className="text-center zero color-white">{t('iMonitor')}</h3>
            </Grid>) : (
                <Grid item xs={10} className="zero appnameholder">
                  <p className="zero text-center">
                    {
                      isLoading ? (
                        <Loader isLoading={isLoading} />
                      ) : (<img className="oneimpactlogoimg" src={headerlogo} />)
                    }
                  </p>
                </Grid>)
            }



            <Grid item xs={1} className="zero">
              <IconButton
                edge="end"
                color="inherit"
                aria-label="home"
                className="homeicon-btn menubtn"
                onClick={() => handleClickHome()}
              >
                <HomeIcon style={colorStyles} />
              </IconButton>
            </Grid>
          </Grid>

          {
            templateID == 2 && (
              <>
                <p className="getonboardedtext text-center">{t(props.location.name)}</p>
                <div className="custom-shape-divider-bottom-1599722124">
                  <svg
                    data-name="Layer 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1200 120"
                    preserveAspectRatio="none"
                  >
                    <path
                      fill={props.componentbgcolor}
                      d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z"
                    ></path>
                  </svg>
                </div>

              </>
            )
          }
        </div>
      </Grid >
      <div className="headerdiv"></div>
    </>
  );
};

//export default (withTranslation()(KnowledgeList));
const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    componentbgcolor: storeState.componentbgcolor
  };
};


const withRouterheader = withRouter(withTranslation()(Header));

export default connect(mapStateToProps, { setcomponentbgcolor })(withRouterheader);

